import { z } from 'zod'

export const batchUpdateIncomesSchema = z.object({
  ids: z.array(z.string().guid()).min(1).max(500),
  categoryId: z.string().guid(),
})

export type BatchUpdateIncomesDto = z.infer<typeof batchUpdateIncomesSchema>
